import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import AdminDashboard from "../components/admin/AdminDashboard";
import AdminLayout from "../components/admin/AdminLayout";

const AdminPage = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const adminDashboardRef = useRef();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const handleCoursesChange = () => {
    // Trigger refresh in AdminDashboard
    if (adminDashboardRef.current && adminDashboardRef.current.refreshData) {
      adminDashboardRef.current.refreshData();
    }
  };

  return (
    <AdminLayout user={user} onLogout={handleLogout} title="Dashboard Administrativo">
      <AdminDashboard ref={adminDashboardRef} user={user} onLogout={handleLogout} onCoursesChange={handleCoursesChange} />
    </AdminLayout>
  );
};

export default AdminPage;
